document.addEventListener("variant:changed", (e) => {
  setTimeout(() => {
    const variant = e.detail.variant;
    if (!variant) return;

    const selectedValue = variant.option1.trim().toLowerCase();

    console.log("Selected Variant:", selectedValue);

    // Main Gallery Images
    const gallerySlides = document.querySelectorAll(
      '#Slider-Gallery li[data-media-alt], [id^="Slider-Gallery-"] li[data-media-alt]'
    );

    // Thumbnail Images
    const thumbnailSlides = document.querySelectorAll(
      '#Slider-Thumbnails li[data-media-alt], [id^="Slider-Thumbnails-"] li[data-media-alt]'
    );

    console.log("Gallery Slides:", gallerySlides.length);
    console.log("Thumbnail Slides:", thumbnailSlides.length);

function filterSlides(slides) {
  slides.forEach((slide) => {
    const alt = (slide.dataset.mediaAlt || "").trim().toLowerCase();

    console.log(
      "Selected:",
      selectedValue,
      "| Alt:",
      alt,
      "| Match:",
      alt === selectedValue
    );

    if (alt === selectedValue) {
      slide.style.display = "";
    } else {
      slide.style.display = "none";
    }
  });
}

    // filterSlides(gallerySlides);
    filterSlides(thumbnailSlides);
  }, 300);
});